import { useParams } from 'react-router-dom';

// const apiGatewayBase = 'http://localhost:8080/beta';
// const apiGatewayBase: any = 'https://api-de-eu.ivicos-campus.app/v0';
const apiGatewayBase = process.env.REACT_APP_GATEWAY_URL;
export const getApiGatewayUrl = (path: string, backendBranch: string): any => {
    if (apiGatewayBase?.endsWith('a') || apiGatewayBase?.endsWith('v0')) {
        return `${apiGatewayBase}/${path}/${backendBranch}`;
    } else {
        return `${apiGatewayBase}/${path}`;
    }
};

export const getUrlLocation = (): { isInDashboardLobby: boolean; isInDashboardLevel0: boolean; isInDashboardLevel1: boolean; isInsideArea: boolean } => {
    const { groupId, groupLevel, areaId } = useParams<{ groupId?: string; groupLevel?: string; areaId?: string }>();
    const path = window.location.pathname;

    const isInDashboardLobby =
        path === '/dashboard/areas' || path === '/dashboard' || path === '/areas' || (path === '/' && !areaId && !groupId && !groupLevel);

    const isInDashboardLevel0 = Boolean(groupId && groupLevel === 'L0' && !areaId);
    const isInDashboardLevel1 = Boolean(groupId && groupLevel === 'L1' && !areaId);
    const isInsideArea = Boolean(areaId && !groupId && !groupLevel);

    return {
        isInDashboardLobby,
        isInDashboardLevel0,
        isInDashboardLevel1,
        isInsideArea
    };
};
